import  React,{useState,useEffect} from 'react';
import axios from "../../../lib/axios";
import { useNavigate } from 'react-router-dom';
import TableComponent from '../../../atoms/TableComponent/DataTable';
import { usePermissions } from '../../../GlobalFunction/userPermissions';
import { Box, Button, Tooltip } from '@mui/material';

const columns = [
  { id: 'RowNum', label: 'Sr.No.', minWidth: 170 },
  { id: 'PropName', label: 'Property', minWidth: 170 },
  { id: 'AuthToken', label: 'AuthToken', minWidth: 170 },
  { id: 'ApiKey', label: 'ApiKey', minWidth: 100 },
  { id: 'SaltKey', label: 'SaltKey', minWidth: 100 },
  { id: 'ClientSecretKey', label: 'ClientID', minWidth: 170 },
  { id: 'ClientKey', label: 'ClientSecretKey', minWidth: 170 },
  { id: 'Status', label: 'Status', minWidth: 170 }
];

export default function PaymentGatewayConfigTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [searchTerms, setSearchTerms] = useState({});
  const [ValueToSearch,setValueToSearch] = useState("");

  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPaymentGatewayConfig(); 
  }, []);

  const permissions = usePermissions("Payment Gateway Configuration");

  const { AddRec = "0" } = permissions || {};

  const handlePermittedClick = () => {
    if (AddRec === "1") {
      handleClick();
    }
  };

  const fetchPaymentGatewayConfig = async (searchText = "") => {
    try {
      const response = await axios.post('PytGatewayConfig/GetPytGatewayConfigDashBoard', {
        start: 0,
        PageSize: 0,
        SearchText: searchText
      });
      
      if (response.data.Status === 0) {
        const formattedData = response.data.Data.map(payment => ({
          ...payment,
          PropName: payment.PropName || '',
          AuthToken: payment.AuthToken || '', 
          ApiKey: payment.ApiKey || '',
          SaltKey: payment.SaltKey,
          ClientSecretKey: payment.ClientSecretKey,
          ClientKey: payment.ClientKey,
          Status: payment.Status === 1 ? 'Inactive' : 'Active'
        }));
        setRows(formattedData);
        
      } else {
        console.error('Error fetching payment gateway config data:', response.data.message);
      }
    } catch (error) {
      console.error('Error fetching payment gateway config data:', error);
    }
  };

  const handleSearch = (value) => {
    fetchPaymentGatewayConfig(value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClick = () => {
    navigate('/paymentGatewayConfig');
  };

  const handleHomeClick = () => {
    navigate('/dashboard');
  };

  const handleSearchChange = (columnId, value) => {
    setValueToSearch(value);
    setSearchTerms(prev => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const filteredRows = React.useMemo(() => {

    return rows.filter(row => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        if (typeof value === 'string') {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === 'number') {
          return value.toString().includes(term);
        }
        return true;
      });
    });
  }, [searchTerms, rows]);

  const handleRowDoubleClick = (row) => {
  
    navigate('/paymentGatewayConfig', { state: { PgConfigId: row.PgConfigId, mode: 'view' } } );
  };

  const handleLocationclick=()=>{
    navigate('/masters/control-security')
  } 

  const handleIconClick = ()=>{
    fetchPaymentGatewayConfig(ValueToSearch);
  }

  const addButtonStyles = {
    background: AddRec === "1" ? "#635bff" : "rgba(0, 0, 0, 0.12)",
    color: AddRec === "1" ? "white" : "rgba(0, 0, 0, 0.26)",
    borderRadius: "50px",
    padding: "8px 20px",
    boxShadow: AddRec === "1" ? "0px 6px 15px rgba(0, 0, 0, 0.3)" : "none",
    transition: "background 0.3s ease",
    "&:hover": {
      background: AddRec === "1" ? "#524ccc" : "rgba(0, 0, 0, 0.12)"
    },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)"
    }
  };

  const Filters = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Tooltip
        title={AddRec !== "1" ? "You have no permission to add record" : ""}
        placement="top"
      >
        <span>
          <Button
            variant="contained"
            onClick={handlePermittedClick}
            size="small"
            disabled={AddRec !== "1"}
            sx={addButtonStyles}
          >
            Add New Record
          </Button>
        </span>
      </Tooltip>
    </Box>
  );

  return (

    <TableComponent
      columns={columns}
      rows={rows}
      filteredRows={filteredRows}
      page={page}
      title="Control & Security"
      titleMaster="PaymentGateway Master"
      rowsPerPage={rowsPerPage}
      FiltersJsx={Filters}
      handleRowDoubleClick={handleRowDoubleClick}
      handleSearchChange={handleSearchChange}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      handleClick={handleClick}
      handleHomeClick={handleHomeClick}
      handleLocationclick={handleLocationclick}
      handleIconClick={handleIconClick}
    />
  );
}